import useAdditionalParameters from '../hooks/useAdditionalParameters';
import { useCheckLoadedAndShow } from '../hooks/useCheckLoadedAndShow';
import useLocationLoadCompleteCallback from '../hooks/useLocationLoadCompleteCallback';
// Some valid URLs:
// https://us241.dayforcehcm.com/MyDayforce/u/tUBXdwtgX0O2K1qlW07azw/Common/
// https://us241.dayforcehcm.com/MyDayforce/u/asbbp_ZmikyVqCIjCtJzVQ/Common/
// This regex enforces:
// - no "." characters with [^.]+
// - no "/" characters with [^/]+
export var CERIDIAN_FINAL_DEST_REGEXP = /https:\/\/[^.]+.dayforcehcm.com\/MyDayforce\/u\/[^/]+\/Common\//;
export function useCeridian() {
    var addAdditionalParameters = useAdditionalParameters().addAdditionalParameters;
    useLocationLoadCompleteCallback(CERIDIAN_FINAL_DEST_REGEXP, function (landingUrl) {
        addAdditionalParameters({ landingUrl: landingUrl });
    });
    useCheckLoadedAndShow();
}
